module.exports = __webpack_public_path__ + "img/download-empty.7172624b.png";